import { useCallback } from 'react';
import { trackAnalytics, getTokenCount } from 'common/components/CopyMagic/shared/dataHelpers';
import { useConfigContext } from 'common/components/CopyMagic/contexts';
import { PromptFormValuesType } from 'common/components/CopyMagic/CopyMagic.types';
import { MESSAGE_DATA_ROLES } from 'common/components/CopyMagic/constants';
import { useMessagesContext } from 'common/components/CopyMagic/contexts/MessagesContext';
import useChatSessionId from 'common/components/CopyMagic/hooks/useChatSessionId';

const useTrackOnGenerate = () => {
  const { productEvents } = useConfigContext();
  const { findMessagesBy } = useMessagesContext();
  const { getChatSessionId } = useChatSessionId();

  const trackCallback = useCallback(
    ({ promptValues }: { promptValues: PromptFormValuesType }) => {
      const trackProductAnalytics = trackAnalytics(productEvents);
      const chatSessionId = getChatSessionId();

      trackProductAnalytics('Prompt Sent', {
        'Input': promptValues.topic,
        'User Messages Count': findMessagesBy({ role: MESSAGE_DATA_ROLES.USER }).length,
        'Tokens Sent': getTokenCount(promptValues.topic),
        'Chat Session ID': chatSessionId,
      });
    },
    [productEvents, findMessagesBy],
  );

  return trackCallback;
};

export default useTrackOnGenerate;
